import React from "react";
import ValidatedInput from "../../../commonComponents/util/ValidatedInput";
import CurrencyFormatInput from "../../../commonComponents/util/CurrencyFormatInput";
import { formatDate, formatDateForInput, toTitleCase } from "../../../../lib/utils";

export default class BankReconciliationStep1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitAttempted: false
    };
  }

  continue() {
    if (!this.state.submitAttempted) this.setState({ submitAttempted: true });
    const report = this.props.report;
    if (
      report.reportName &&
      report.dateTo &&
      report.statementBalance
    ) {
      this.props.continue();
    }
  }

  render() {
    const { report, isIsraeli, onChange, wasPreviouslyReconciled } = this.props;
    const { submitAttempted } = this.state;
    return (
      <div>
        <div className="bordered-modal-header">
            <div>
                <h4 className="page-header">{`Reconcile - ${this.props.fundName}`}</h4>
            </div>
            <i className="icon ion-ios-close-empty" onClick={this.props.cancel}/>
        </div>

        <div className="modal-section">
          <ValidatedInput
            input={<input type="text" />}
            required={true}
            showRequiredError={submitAttempted}
            value={report.reportName}
            onChange={(name, value) => onChange(name, toTitleCase(value))}
            name="reportName"
            label="Report Name"
          />
        </div>

        <div className="modal-section">
          <div className="modal-row">
            <div className="column-half">
              <label className="input-label">
                {wasPreviouslyReconciled ? "Date of Last Reconciliation" : "Fund Start Date"}
              </label>
              <p className="mt-16">{formatDate(report.dateFrom)}</p>
            </div>
            <div className="column-half">
              <ValidatedInput
                input={<input type="date" min={formatDateForInput(report.dateFrom)} max="9999-12-31"/>}
                value={formatDateForInput(report.dateTo)}
                name="dateTo"
                onChange={onChange}
                required={true}
                showRequiredError={submitAttempted}
                label="To - Enter Bank Statement Date"
              />
            </div>
          </div>
        </div>

        <div className="modal-section">
          <ValidatedInput
            input={
              <CurrencyFormatInput
                allowNegative={true}
                allowZero={true}
                isIsraeli={isIsraeli}
              />
            }
            label="Bank Statement Balance"
            name="statementBalance"
            onChange={onChange}
            required={true}
            showRequiredError={submitAttempted}
            value={report.statementBalance}
            zeroAsValue={true}
          />
        </div>

        <div className="modal-btns text-right">
          <button className="btn btn-accent" onClick={this.props.cancel}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={this.continue.bind(this)}
          >
            Continue
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/NewBankReconciliation/BankReconciliationStep1.jsx